
export const HAS_DONE_WARMUP = 'has_done_warmup';

/*
User data based info is cached in the sessionStorage to handle cases where multiple
users are sharing a device. The warmup and times finished values are properly stored
in the DB, and loaded into the cache via the AppInitContext on page load.
 */

export function setHasDoneWarmupInCache(hasDoneWarmup: boolean) {
    sessionStorage.setItem(HAS_DONE_WARMUP, hasDoneWarmup ? 'true' : 'false');
}

export function getHasDoneWarmupFromCache(): boolean | undefined {
    const str = sessionStorage.getItem(HAS_DONE_WARMUP);
    return str === null ? undefined : str === 'true';
}
